(function () {
  function setStickyVisible(sticky, visible) {
    sticky.classList.toggle("is-visible", visible);
    sticky.setAttribute("aria-hidden", visible ? "false" : "true");
  }

  function getFooterEl() {
    return (
      document.querySelector(".shopify-section--footer-v3") ||
      document.querySelector(".shopify-section--footer") ||
      document.querySelector("footer") ||
      document.getElementById("shopify-section-footer")
    );
  }

  function wireStickyActions(sectionRoot, sticky) {
    var stickyAtc = sticky.querySelector("[data-sticky-add-to-cart]");
    var mainAtc = sectionRoot.querySelector("[data-add-to-cart]");
    if (stickyAtc && mainAtc) {
      stickyAtc.addEventListener("click", function () {
        if (stickyAtc.disabled) return;
        mainAtc.click();
      });
    }

    var stickyPayment = sticky.querySelector("[data-sticky-payment]");
    if (stickyPayment) {
      stickyPayment.addEventListener("click", function () {
        if (stickyPayment.disabled) return;
        var paymentBtn = sectionRoot.querySelector(
          ".product-v3__btn-cell--payment .shopify-payment-button__button"
        );
        if (paymentBtn) paymentBtn.click();
      });
    }
  }

  function observeTriggerPast(triggerEl, onChange) {
    if (!triggerEl || !window.IntersectionObserver) return null;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          // 模块底部已离开视口上方 = 已划过该模块
          onChange(!entry.isIntersecting && entry.boundingClientRect.bottom < 0);
        });
      },
      { root: null, threshold: 0, rootMargin: "0px" }
    );
    observer.observe(triggerEl);
    return observer;
  }

  function observeFooter(onChange) {
    var footer = getFooterEl();
    if (!footer || !window.IntersectionObserver) return null;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          onChange(entry.isIntersecting);
        });
      },
      { root: null, threshold: 0, rootMargin: "0px" }
    );
    observer.observe(footer);
    return observer;
  }

  function initStandaloneStickyBar(sectionRoot, sticky) {
    wireStickyActions(sectionRoot, sticky);
    setStickyVisible(sticky, false);

    var selector = sectionRoot.getAttribute("data-sticky-trigger-selector");
    var triggerEl = selector ? document.querySelector(selector) : null;
    if (!triggerEl) {
      console.warn(
        "[product-v3-sticky] Trigger not found:",
        selector || "(empty)"
      );
      return;
    }

    var triggerPast = false;
    var footerIn = false;

    function syncVisible() {
      setStickyVisible(sticky, triggerPast && !footerIn);
    }

    observeTriggerPast(triggerEl, function (past) {
      triggerPast = past;
      syncVisible();
    });
    observeFooter(function (inView) {
      footerIn = inView;
      syncVisible();
    });
  }

  function initStickyBar(sectionRoot) {
    var sticky = sectionRoot.querySelector("[data-product-v3-sticky]");
    if (!sticky) return;

    if (sectionRoot.hasAttribute("data-product-v3-sticky-standalone")) {
      initStandaloneStickyBar(sectionRoot, sticky);
      return;
    }

    var purchase = sectionRoot.querySelector("[data-product-v3-purchase]");
    if (!purchase) return;

    var purchasePast = false;
    var footerIn = false;

    function syncVisible() {
      setStickyVisible(sticky, purchasePast && !footerIn);
    }

    observeTriggerPast(purchase, function (past) {
      purchasePast = past;
      syncVisible();
    });
    observeFooter(function (inView) {
      footerIn = inView;
      syncVisible();
    });
    wireStickyActions(sectionRoot, sticky);
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-product-v3]").forEach(initStickyBar);
  });
})();
